import ReCAPTCHA from "react-google-recaptcha";
import { useRef } from "react";
import { ICaptchaProvider, CaptchaProps } from "./ICaptchaProvider";

const RecaptchaComponent: React.FC<CaptchaProps> = ({ onToken }) => {
  const ref = useRef<ReCAPTCHA>(null);

  return (
    <ReCAPTCHA
      ref={ref}
      sitekey={window._env_?.RECAPTCHA_SITE_KEY || ""}
      onChange={(token) => onToken(token || "")}
      onExpired={() => {
        onToken("");
        ref.current?.reset();
      }}
    />
  );
};

export const RecaptchaProvider: ICaptchaProvider = {
  Component: RecaptchaComponent,
};
